var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-zhaopin-list" }, [
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            {
              class: ["item"],
              on: {
                click: function ($event) {
                  return _vm.goDetail(item)
                },
              },
            },
            [
              _c("div", { staticClass: "job-detail" }, [
                _c("img", {
                  staticClass: "logo",
                  attrs: { src: item.pic_path },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "job-name" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tag-list" }, [
                    _c("span", { staticClass: "tag" }, [
                      _vm._v(_vm._s(item.gzqy)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "tag" }, [
                      _vm._v(_vm._s(item.gznx)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "tag" }, [
                      _vm._v(_vm._s(item.xueli)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "job-position" }, [
                    _vm._v(_vm._s(item.md_name)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "salary" }, [
                    _vm._v(_vm._s(item.xinzi)),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _vm.hasMore
          ? _c("div", { staticClass: "next", on: { click: _vm.nextPage } }, [
              _vm._v("下一页"),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v(" 暂无数据 ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }